import Rx from 'rxjs';
import { fromJS } from 'immutable';
import { combineEpics } from 'redux-observable';

import { request } from 'core/generalFunctions';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import * as reportesActions from './action';
import { REPORTES_GET, REPORTES_SOLUCIONADO, REPORTES_SOLUCIONAR_MULTIPLE, REPORTES_CUANTOS_HAY } from 'root/actionConstants';

const { ajax } = Rx.Observable;

export const reportesGetEpic = (action$, store) =>
  action$.ofType(REPORTES_GET).switchMap(action =>
    ajax(request(action))
      .switchMap(({ response }) => {
        if (Array.isArray(response)) {
          let stateToSet = {};
          if (response.length > 0)
            stateToSet = {
              scrollControl: { hasMore: true, page: action.payload.skip / 50 + 1, fecha: action.payload.fecha },
              lista: store
                .getState()
                .getIn(['reportes', 'lista'])
                .concat(fromJS(response)),
            };
          else stateToSet.scrollControl = { hasMore: false, page: 0, fecha: new Date() };

          return Rx.Observable.of(reportesActions.setState(stateToSet));
        }
        return Rx.Observable.empty();
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const reportesCuantosHayEpic = (action$, store) =>
  action$.ofType(REPORTES_CUANTOS_HAY).switchMap(action =>
    ajax(request(action))
      .switchMap(({ response }) => {
        if (response) return Rx.Observable.of(reportesActions.setState({ cuantosHay: response }));
        return Rx.Observable.empty();
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const reportesSolucionarEpic = (action$, store) =>
  action$.ofType(REPORTES_SOLUCIONADO).switchMap(action =>
    ajax(request(action))
      .mergeMap(() => {
        let index = null;
        const lista = store.getState().getIn(['reportes', 'lista']);
        const reporteUpd = lista.find((itm, i) => {
          index = i;
          return itm && itm.get('id') === action.payload.reporteId;
        });
        return [reportesActions.getCantidadReportes(), reportesActions.setState({ lista: lista.set(index, reporteUpd.set('solucionado', true)) })];
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const reportesSolucionarCorrectosEpic = (action$, store) =>
  action$.ofType(REPORTES_SOLUCIONAR_MULTIPLE).switchMap(action =>
    ajax(request(action))
      .map(() => {
        alert('Reportes solucionados: ' + action.payload.reportes.length);
        const lista = store.getState().getIn(['reportes', 'lista']);
        return reportesActions.setState({
          lista: lista.map(reporte => {
            if (reporte && action.payload.reportes.find(id => id === reporte.get('id'))) {
              return reporte.set('solucionado', true);
            }
            return reporte;
          }),
        });
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export default combineEpics(reportesGetEpic, reportesSolucionarEpic, reportesSolucionarCorrectosEpic, reportesCuantosHayEpic);



// WEBPACK FOOTER //
// src/modules/reportes/epics.js